module.exports = __webpack_public_path__ + "img/engagement_4.e8e86a1d.jpg";